import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';

import { Filter } from '../../shared/filter';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { QuotaItem, QuotaFilter } from '../../_models/quota-item';
import { Ship } from '../../_models/ship';
import { Stock } from '../../_models/stock';
import { ShipService } from '../../_services/ship.service';
import { StockService } from '../../_services/stock.service';

@Component({
  selector: 'app-quota-filter',
  templateUrl: './quota-filter.component.html',
})
export class QuotaFilterComponent extends Filter implements OnInit {
  @Input() filterParams: any[];
  @Output() onApplyFilter = new EventEmitter<string>();

  form: FormGroup;
  filter: QuotaFilter;

  ships: SelectItem[] = [];
  stocks: Stock[] = [];
  years: string[] = [];

  selectedShips: Ship[] = [];
  selectedStock: Stock[] = [];

  constructor(
    private fb: FormBuilder,
    private shipService: ShipService,
    private stockService: StockService,
    private router: Router,
    private httpErrorHandler: HttpErrorHandler
  ) {
    super();

    this.years = QuotaItem.getYears();

    this.form = fb.group({
      ship: [''],
      stock: [''],
      year: [''],
    });
  }

  ngOnInit() {
    this.filter = new QuotaFilter(this.filterParams);
    this.getShips();
    this.getStocks();
  }

  getShips() {
    this.shipService.list(1, 1000, '', '').subscribe(
      (response) => {
        this.ships = this.parseDropdownResults(response.results, new Ship(), 'name', false);
        this.selectedShips = this.selectMultipleDropdownItems(response.results, this.filter.ships);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  getStocks() {
    this.stockService.list(1, 1000, '', '').subscribe(
      (response) => {
        this.stocks = this.parseDropdownResults(response.results, new Stock(), 'full_name', false);
        this.selectedStock = this.selectMultipleDropdownItems(response.results, this.filter.stock);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  onSubmit() {
    this.filter.ships = [];
    if (this.selectedShips) {
      this.filter.ships = this.selectedShips;
    }

    this.filter.stock = this.selectedStock || [];

    if (this.filterParams['o'] !== undefined) {
      this.filter['o'] = this.filterParams['o'];
    }

    this.applyFilter(QuotaFilter.serializeRouterParams(this.filter));
  }

  protected applyFilter(params) {
    this.onApplyFilter.emit(params);
  }
}



// WEBPACK FOOTER //
// ./src/app/quotas/quota-filter/quota-filter.component.ts